import { Outlet } from "@tanstack/react-router";

import { Footer } from "@/components/footer";
import Header from "@/components/header";

export function AboutLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header showSearch={false} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
